import { data } from "./data";
import { useState } from "react";
import bg from "../../images/technology/background-technology-tablet.jpg";
import NavBar from "../navbar/MainNavBar";
const DeskTech = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const render = data[currentPage];
  const myStyle = {
    backgroundImage: `url(${bg})`,
    backgroundSize: "cover",
    minHeight: "100vh",
  };
  const handleGoTo = (dataIndex) => {
    setCurrentPage(dataIndex);
  };
  return (
    <div style={myStyle}>
      <NavBar />
      <p className="p-style" style={{ margin: "2rem 2rem 0.5rem 10%" }}>
        {" "}
        <strong className="strong">03</strong>SPACE LAUNCH 101
      </p>
      <div
        style={{
          textAlign: "left",
          display: "flex",
          flexDirection: "row",
          width: "90%",
          position: "absolute",
          right: 0,
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div className="tech-circle-box">
          {data.map((data, dataIndex) => (
            <div
              key={dataIndex}
              className={
                dataIndex === currentPage ? "active-tech-box" : "tech-box"
              }
              onClick={() => handleGoTo(dataIndex)}
            >
              {dataIndex + 1}
            </div>
          ))}
        </div>

        <div
          style={{
            padding: "0 2rem",
            textAlign: "left",
            paddingBottom: "3rem",
            width: "30rem",
            marginLeft: "-10%",
          }}
        >
          <h4
            style={{
              textTransform: "uppercase",
              marginTop: "-.5rem",
              fontSize: "16px",
            }}
          >
            THE TERMINOLOGY...
          </h4>
          <h3
            style={{
              margin: ".5rem 0 1rem",
              textTransform: "uppercase",
              fontSize: "40px",
              lineHeight: "46px",
            }}
          >
            {render.terminology}
          </h3>
          <p
            style={{
              fontSize: "16px",
              lineHeight: "28px",
              width: "60%",
            }}
          >
            {render.text}
          </p>
        </div>
        <img
          src={render.img}
          style={{ height: "29rem", marginTop: "3.5rem", width: "31rem" }}
        />
      </div>
    </div>
  );
};
export default DeskTech;
